import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import heic2any from "heic2any";
import { useGetDocumentById } from "../../hooks/ReactQueryHooks/useGetDocument";

export function AttachmentModal({ modalShow, handleShow, documentData, url, docData, fromDocument }) {
    const fileExtension = url?.split(".").pop();
    const [document, setDocument] = useState(null);
    const [convertedUrl, setConvertedUrl] = useState(null);
    const [loadingData, setLoadingData] = useState(false);
    const [error, setError] = useState("");

    useGetDocumentById({ onSuccess: setDocument, id: docData?.id });

    useEffect(() => {
        let objectUrl;
        let cancelled = false;

        const prepareDocument = async () => {
            setError("");
            if (fileExtension === "heic") {
                try {
                    setLoadingData(true);
                    const blob = await fetch(documentData?.signedUrl).then((response) => response.blob());
                    const convertedBlob = await heic2any({ blob });
                    objectUrl = URL.createObjectURL(convertedBlob);
                    if (!cancelled) setConvertedUrl(objectUrl);
                } catch {
                    if (!cancelled) setConvertedUrl(documentData?.signedUrl);
                } finally {
                    if (!cancelled) setLoadingData(false);
                }
                return;
            }

            setConvertedUrl(documentData?.signedUrl);
            const image = new Image();
            image.onerror = () => {
                if (!cancelled) setError("The file you are attempting to access is not compatible.");
            };
            image.src = documentData?.signedUrl;
        };

        prepareDocument();
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [documentData?.signedUrl, fileExtension]);

    const source = fromDocument
        ? document?.content?.[0]?.attachment?.base64String
        : convertedUrl;

    return (
        <Modal
            backdropClassName
            backdrop="static"
            size="xl"
            show={modalShow}
            onHide={handleShow}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="custom-dialog"
        >
            <Modal.Header closeButton className="border-0" />
            <Modal.Body>
                <Box sx={{ width: "100%", overflow: "hidden" }}>
                    {loadingData ? (
                        <div className="box-wrap" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "10vh" }}>
                            <CircularProgress />
                        </div>
                    ) : fileExtension === "pdf" ? (
                        document?.code === "AccessDenied" ? (
                            <span>{document?.message}</span>
                        ) : (
                            <iframe title="Document preview" src={source} width="1100" height="1100" />
                        )
                    ) : error ? (
                        <span className="jpg-img-error">{error}</span>
                    ) : (
                        <img src={source} width="1100" height="1100" alt="Document preview" />
                    )}
                </Box>
            </Modal.Body>
        </Modal>
    );
}
